import { FC } from 'react';
import './index.scss';
import { DEFAULT_LABELS } from './model';
import StreamlineComponent from './streamline/StreamlineComponent';
import RetailComponent from './retail/RetailComponent';
import BrandsAboutComponent from './brands/BrandsAboutComponent';
import ExhibitAboutComponent from './exhibit/ExhibitAboutComponent';
import MoreAboutComponent from './more/MoreAboutComponent';
import PartnersAboutComponent from './partners/PartnersAboutComponent';
import TransparencyAboutComponent from './transparency/TransparencyAboutComponent';
import BuyersAboutComponent from './buyers/BuyersAboutComponent';
import ArticlesAboutComponent from './articles/ArticlesAboutComponent';

const AboutComponent: FC = () => {
	return (
		<div className='about-container'>
			<h1 className='main-title'>{DEFAULT_LABELS.title}</h1>
			<StreamlineComponent />
			<RetailComponent />
			<BrandsAboutComponent />
			<BuyersAboutComponent />
			<ExhibitAboutComponent />
			<MoreAboutComponent />
			<PartnersAboutComponent />
			<ArticlesAboutComponent />
			<TransparencyAboutComponent />
		</div>
	);
};

export default AboutComponent;
